export function lcm( n: number, m: number ): number {
	return m * ( n / gcd( n, m ) );
}

function gcd( n: number, m: number ): number {
	return m === 0 ? Math.abs( n ) : gcd( m, n % m );
}
